export interface ProductContainerData {
  title: string;
  attributes: string[];
  action: string;
  stock: number;
  updatedAt: string;
  url: string;
  stockType: string;
  image?: string;
}

const badgeText = {
  PRODUCTS_ACTION_PUSH_DOWN: "Low on stock",
  PRODUCTS_ACTION_HIDE: "Out of stock",
  OUT_STOCK: "Out of stock",
  LOW_STOCK: "Low on stock",
  BACK_STOCK: "Back in stock",
};

const BasedOnStockLevelContainer = () => (`
  <div style="margin-bottom:18px">
    <div style="font-weight: 700;color: #000001;">Products targeted based on stock level</div>
  </div>
`);

const BasedOnAttributesContainer = (attributes: string[]) => (`
  <div style="margin-bottom:18px">
    <div style="font-weight: 700;color: #000001;">Products targeted based on their attributes:</div>
    <div style="color: #000001;">${attributes.join(",")}</div>
  </div>
`);

export const ProductContainer = (data: ProductContainerData, actionType: string) => (`
  <div style="padding: 22px 32px;border-radius: 5px;background: #FFF; margin-bottom: 30px">
    <div class="product-container--left-block">
      <a style="display: block;color: #6E5BEA;font-size: 16px;font-weight: 600;line-height: 20px;text-decoration: underline;margin-bottom: 15px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" clicktracking="off" href="${data.url}">${data.title}</a>
      <div class="product-container--image product-container--image-desktop" style="background-image: url(${data.image});">
        ${actionType === "ACTION_TYPE_STOCK" ? `<div style="display: inline-block;position: absolute;background-color: #6E5BEA;color: #FFF;font-weight: 600;font-size: 11px;padding: 4px 6px;border-radius: 5px;margin-left: 10px;margin-top: 10px;">${badgeText[data.stockType]}</div>` : ""}
      </div>
    </div>
    <div class="product-container--right-block">
      ${actionType === "ACTION_TYPE_STOCK" ? BasedOnStockLevelContainer() : BasedOnAttributesContainer(data.attributes)}
      <div style="margin-bottom:18px">
        <div style="font-weight: 700;color: #000001;">Action Taken:</div>
        <div style="color: #000001;">${data.action}</div>
      </div>
      <div style="margin-bottom:18px">
        <div style="font-weight: 700;color: #000001;">Stock:</div>
        <div style="color: #000001;">${data.stock}</div>
      </div>
      <div style="margin-bottom:18px">
        <div style="font-weight: 700;">Updated date & time:</div>
        <div style="color: #000001;">${data.updatedAt}</div>
      </div>
      <div class="product-container--image product-container--image-mobile" style="background-image: url(${data.image});">
        ${actionType === "ACTION_TYPE_STOCK" ? `<div style="display: inline-block;position: absolute;background-color: #6E5BEA;color: #FFF;font-weight: 600;font-size: 11px;padding: 4px 6px;border-radius: 5px;margin-left: 10px;margin-top: 10px;">${badgeText[data.stockType]}</div>` : ""}
      </div>
    </div>
  </div>
`);